import { FC } from "react";
import { Benefit } from "@commons-monorepo/index";
import Benefits1 from "./skins/benefits-1/benefits-1";
import Benefits2 from "./skins/benefits-2/benefits-2";
import Benefits3 from "./skins/benefits-3/benefits-3";
import { WidgetProps, WidgetType } from "@commons-monorepo/index";

const Benefits: FC<
  WidgetProps<Benefit[], { highlight_background: boolean }>
> = ({ id, data, config, type }) => {
  return data ? (
    <div id={id}>
      {type === WidgetType.BENEFITS_1 && (
        <Benefits1 benefits={data} highLight={config.highlight_background} />
      )}
      {type === WidgetType.BENEFITS_2 && (
        <Benefits2 benefits={data} highLight={config.highlight_background} />
      )}
      {type === WidgetType.BENEFITS_3 && (
        <Benefits3 benefits={data} highLight={config.highlight_background} />
      )}
    </div>
  ) : (
    <></>
  );
};

export default Benefits;
